package com.tovtalk.data.repository

import com.tovtalk.data.mapper.toPost
import com.tovtalk.data.remote.ApiClient
import com.tovtalk.data.remote.ApiEndpoints
import com.tovtalk.data.remote.dto.HashtagListResponse
import com.tovtalk.data.remote.dto.HashtagPostsResponse
import com.tovtalk.domain.entity.Post
import com.tovtalk.domain.repository.HashtagInfo
import com.tovtalk.domain.repository.HashtagRepository
import com.tovtalk.domain.entity.DomainResult
import io.ktor.client.call.*
import io.ktor.client.request.*

class HashtagRepositoryImpl(
    private val apiClient: ApiClient
) : HashtagRepository {
    private val bandwidth get() = apiClient.bandwidthEstimator

    override suspend fun getPostsByHashtag(
        tag: String,
        limit: Int,
        cursor: String?
    ): DomainResult<Pair<List<Post>, String?>> = try {
        val response = apiClient.httpClient.get("${ApiEndpoints.HASHTAG_POSTS}/$tag/posts") {
            parameter("limit", limit)
            cursor?.let { parameter("cursor", it) }
        }.body<HashtagPostsResponse>()

        val posts = response.data.items.map { it.toPost(bandwidth) }
        DomainResult.Success(Pair(posts, response.data.nextCursor))
    } catch (e: Exception) {
        DomainResult.Error(e.message ?: "Failed to fetch hashtag posts")
    }

    override suspend fun getTrending(limit: Int): DomainResult<List<HashtagInfo>> = try {
        val response = apiClient.httpClient.get(ApiEndpoints.HASHTAG_TRENDING) {
            parameter("limit", limit)
        }.body<HashtagListResponse>()

        val hashtags = response.data.hashtags.map {
            HashtagInfo(hashtag = it.hashtag, postCount = it.postCount)
        }
        DomainResult.Success(hashtags)
    } catch (e: Exception) {
        DomainResult.Error(e.message ?: "Failed to fetch trending hashtags")
    }

    override suspend fun searchHashtags(query: String, limit: Int): DomainResult<List<HashtagInfo>> = try {
        val response = apiClient.httpClient.get(ApiEndpoints.HASHTAG_SEARCH) {
            parameter("q", query)
            parameter("limit", limit)
        }.body<HashtagListResponse>()

        val hashtags = response.data.hashtags.map {
            HashtagInfo(hashtag = it.hashtag, postCount = it.postCount)
        }
        DomainResult.Success(hashtags)
    } catch (e: Exception) {
        DomainResult.Error(e.message ?: "Failed to search hashtags")
    }
}
